import { render, staticRenderFns } from "./MenuTipoPessoa.vue?vue&type=template&id=74b0530a&"
import script from "./MenuTipoPessoa.vue?vue&type=script&lang=js&"
export * from "./MenuTipoPessoa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports